import React from 'react';
import { Button, Stack, useWindowProperties } from '@qred/components-library';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { updateForm } from '~/store/slices/loanOffer.slice';
import useGoToNextStep from '../../hooks/useGoToNextStep';
import { useBankInformationFooter } from './BankInformationFooterContext';

const BankInformationFooter = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { isMobile } = useWindowProperties();
  const onNextStepClick = useGoToNextStep();
  const {
    isBankSearchShown,
    hasNoSearchResults,
    setStartAuthorizationContainer,
  } = useBankInformationFooter();

  const onAddManuallyClick = () => {
    dispatch(
      pushToGtmLoanAction({
        actionName: 'add_manually_button_pressed',
      })
    );
    dispatch(updateForm({ accountNumber: '' }));
  };

  if (isBankSearchShown && hasNoSearchResults) {
    return (
      <Button
        onClick={onAddManuallyClick}
        rightIcon="east"
        size="md"
        fullWidth={isMobile}
        compact
      >
        <span data-record>
          {translate('OnboardingOffer.AddManuallyButtonText')}
        </span>
      </Button>
    );
  }

  if (isBankSearchShown) {
    // BankConnection renders its "Verify with your bank" button in here
    return <Stack ref={setStartAuthorizationContainer} w="100%" />;
  }

  return <NextButton label="OnboardingOffer.Next" action={onNextStepClick} />;
};

export default BankInformationFooter;
